import React, { useState, useEffect } from "react";
import {
  Typography,
  makeStyles,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { useHistory } from "react-router-dom";

import Loader from "../../components/Loader";
import axios from "axios";

import { DIESEL_SUPERVISOR } from "../../configs/urls";

import { getApi } from "../../services/api";
import { DatePicker } from "@material-ui/pickers";
import moment from "moment";
import ReactHtmlTableToExcel from "react-html-table-to-excel";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "100%",
    margin: "auto",
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
  listContainer: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  clearAllButton: {
    minWidth: "130px !important",
    paddingLeft: 8,
    paddingRight: 8,
    marginTop: 10,
    paddingBottom: 3,
    marginLeft: 20,
  },
}));

export default function DieselSupervisors(props) {
  const classes = useStyles();
  const [supervisorList, setDieselSupervirsorList] = useState([]);
  const history = useHistory();
  const [isRequesting, setIsRequestig] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [fromDate, setFromDate] = useState(moment().startOf("month"));
  const [toDate, setToDate] = useState(fromDate);

  useEffect(() => {
    getAllData();
  }, []); //eslint-disable-line

  const getAllData = () => {
    setIsRequestig(true);
    const supervisors = getApi(DIESEL_SUPERVISOR, {
      fromDate: fromDate.format("YYYY-MM-DD"),
      toDate: toDate.format("YYYY-MM-DD"),
    });
    axios
      .all([supervisors])
      .then((res) => {
        if (res[0] && res[0].data) {
          setDieselSupervirsorList(res[0].data);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const renderList = () => (
    <>
      <TableContainer component={Paper}>
        <Table
          id="table-to-xls"
          className={classes.table}
          aria-label="caption table"
        >
          <TableHead>
            <TableRow>
              <TableCell>Sr. No.</TableCell>
              <TableCell>Project Name</TableCell>

              <TableCell>Driver Name</TableCell>
              <TableCell>Vehicle Unique ID</TableCell>
              <TableCell>Diesel Fill Up (Ltrs.)</TableCell>
              <TableCell>Hours Used</TableCell>
              <TableCell>Diesel Supervisor Name</TableCell>
            </TableRow>
          </TableHead>
          {supervisorList.length > 0 ? (
            <TableBody>
              {!filterType ? (
                <>
                  {supervisorList?.map((item, idx) => (
                    <TableRow key={idx}>
                      <TableCell component="th" scope="row">
                        {idx + 1}
                      </TableCell>
                      <TableCell>{item?.name || "--"}</TableCell>

                      <TableCell>{item?.item?.driver?.name || "--"}</TableCell>
                      <TableCell>
                        {item.item?.vehicle?.registration_number
                          ? `${item?.item?.vehicle?.registration_number} (${item?.item?.vehicle?.unique_number})`
                          : "--"}
                      </TableCell>
                      <TableCell align="center">
                        {item.item?.diesel_used || "N/A"}
                      </TableCell>
                      <TableCell align="center">
                        {item.item?.hours_used || "N/A"}
                      </TableCell>
                      <TableCell component="th">
                        {item?.item?.diesel_supervisor?.name}
                      </TableCell>
                    </TableRow>
                  ))}
                </>
              ) : (
                <>
                  {supervisorList
                    ?.filter((item) => {
                      if (filterType) {
                        return item?.item?.driver?.id == filterType;
                      }
                    })
                    .map((item, idx) => (
                      <TableRow key={idx}>
                        <TableCell component="th" scope="row">
                          {idx + 1}
                        </TableCell>
                        <TableCell>{item?.name || "--"}</TableCell>

                        <TableCell>
                          {item?.item?.driver?.name || "--"}
                        </TableCell>
                        <TableCell>
                          {item.item?.vehicle?.registration_number
                            ? `${item?.item?.vehicle?.registration_number} (${item?.item?.vehicle?.unique_number})`
                            : "--"}
                        </TableCell>
                        <TableCell align="center">
                          {item.item?.diesel_used || "N/A"}
                        </TableCell>
                        <TableCell align="center">
                          {item.item?.hours_used || "N/A"}
                        </TableCell>
                        <TableCell component="th">
                          {item?.item?.diesel_supervisor?.name}
                        </TableCell>
                      </TableRow>
                    ))}
                </>
              )}
            </TableBody>
          ) : (
            <TableRow>
              <TableCell align="center" colSpan={7}>
                <Box
                  fontSize="h6.fontSize"
                  m={1}
                  p={{ xs: 2, sm: 2, md: 2 }}
                  style={{ textAlign: "center" }}
                >
                  No Records found.
                </Box>
              </TableCell>
            </TableRow>
          )}
        </Table>
      </TableContainer>
    </>
  );
  return (
    <div className={classes.root}>
      <Loader isLoading={isRequesting} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Typography variant="h6" className={classes.title}>
              Diesel Supervisor Statistics
            </Typography>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div>
                <DatePicker
                  autoOk
                  disableToolbar
                  variant="inline"
                  label="Select From Date"
                  value={fromDate}
                  onChange={setFromDate}
                />
                <DatePicker
                  autoOk
                  disableToolbar
                  variant="inline"
                  label="Select To Date"
                  value={toDate}
                  onChange={setToDate}
                />
              </div>
              <FormControl
                variant="outlined"
                style={{ width: "100px", marginLeft: "10px" }}
              >
                <InputLabel id="demo-simple-select-label">Filter</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={filterType}
                  label="Filter"
                  onChange={(e) => {
                    setFilterType(e.target.value);
                  }}
                >
                  {supervisorList?.map((item) => {
                    return (
                      <MenuItem value={item?.item?.driver?.id}>
                        {item?.item?.driver?.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>

              {filterType && (
                <Button
                  onClick={() => {
                    setFilterType();
                  }}
                >
                  Clear
                </Button>
              )}
              <div style={{ marginRight: "20px" }}>
                <ReactHtmlTableToExcel
                  style={{ marginLeft: "100px" }}
                  id="test-table-xls-button"
                  className="download-table-xls-button"
                  table="table-to-xls"
                  filename="tablexls"
                  sheet="tablexls"
                  buttonText="Export Data"
                />
              </div>
            </div>
          </Grid>
          {renderList()}
        </GridItem>
      </GridContainer>
    </div>
  );
}
